var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6h1v1h-1v-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8h1v1h-1v-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10h1v1h-1v-1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12h1v1h-1v-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16h1v1h-1v-1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14h1v1h-1v-1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6h1v1h-1v-1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8h1v1h-1v-1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10h1v1h-1v-1z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12h1v1h-1v-1z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16h1v1h-1v-1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14h1v1h-1v-1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6h1v1h-1v-1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8h1v1h-1v-1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10h1v1h-1v-1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12h1v1h-1v-1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16h1v1h-1v-1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14h1v1h-1v-1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6h1v1h-1v-1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h1v1h-1v-1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10h1v1h-1v-1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12h1v1h-1v-1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16h1v1h-1v-1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14h1v1h-1v-1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19h-0.5v-13.5c0-0.763-0.567-1.549-1.291-1.791l-4.709-1.57v-1.64c0-0.158-0.075-0.307-0.202-0.401s-0.291-0.123-0.442-0.078l-9.042 2.713c-0.737 0.221-1.314 0.997-1.314 1.766v14.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h18c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5zM16.393 4.658c0.318 0.106 0.607 0.507 0.607 0.842v13.5h-5v-15.806l4.393 1.464zM2 4.5c0-0.329 0.287-0.714 0.602-0.808l8.398-2.52v17.828h-9v-14.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkplace);
export default __webpack_public_path__ + "static/media/icon-workplace.c956a9e805b01a2a22b8ca60433ad506.svg";
export { ForwardRef as ReactComponent };